module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.wishes.pick')))]), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'storstenshojden') ? _c('div', [(_vm.params.person.products[0].code.match(/MULTI/)) ? _c('div', [_c('h5', {
    staticClass: "multi"
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.multi-title')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "startSki",
      "iconscale": 2,
      "value": _vm.wishes.startSki,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.skis'),
        unchecked: _vm.$t('skirental.wishes.options.skis')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "startSnowboard",
      "iconscale": 2,
      "value": _vm.wishes.startSnowboard,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.snowboard'),
        unchecked: _vm.$t('skirental.wishes.options.snowboard')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('skirental.wishes.shoes')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "wideCalf",
      "iconscale": 2,
      "value": _vm.wishes.wideCalf,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.wideCalf'),
        unchecked: _vm.$t('skirental.wishes.options.wideCalf')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "wideFoot",
      "iconscale": 2,
      "value": _vm.wishes.wideFoot,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.wideFoot'),
        unchecked: _vm.$t('skirental.wishes.options.wideFoot')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "softShoes",
      "iconscale": 2,
      "value": _vm.wishes.softShoes,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.softShoes'),
        unchecked: _vm.$t('skirental.wishes.options.softShoes')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "hardShoes",
      "iconscale": 2,
      "value": _vm.wishes.hardShoes,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.hardShoes'),
        unchecked: _vm.$t('skirental.wishes.options.hardShoes')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.hasSkis) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.$t('skirental.wishes.skis')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "shortTurn",
      "iconscale": 2,
      "value": _vm.wishes.shortTurn,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.shortTurn'),
        unchecked: _vm.$t('skirental.wishes.options.shortTurn')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "longTurn",
      "iconscale": 2,
      "value": _vm.wishes.longTurn,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.longTurn'),
        unchecked: _vm.$t('skirental.wishes.options.longTurn')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasSnowboard) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.$t('skirental.wishes.snowboard')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.wishes.foot-in-front', {
    name: _vm.params.person.name
  })))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "preferedFootLeft",
      "iconscale": 2,
      "value": _vm.wishes.preferedFootLeft,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.preferedFootLeft'),
        unchecked: _vm.$t('skirental.wishes.options.preferedFootLeft')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "preferedFootRight",
      "iconscale": 2,
      "value": _vm.wishes.preferedFootRight,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.preferedFootRight'),
        unchecked: _vm.$t('skirental.wishes.options.preferedFootRight')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.site === 'branas') ? _c('h5', {
    staticClass: "multi"
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.other')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "full"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.wishes.other-help')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wishes.freeText),
      expression: "wishes.freeText"
    }],
    staticClass: "text-input",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.wishes.freeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wishes, "freeText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.save')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160bc780"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiRentalWishes.vue
// module id = 920
// module chunks = 0